var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWindsurf(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 24,
    viewBox: "0 0 15 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.32621 13.0167L3.25354 10.1197C3.06641 9.61436 3.44484 9.07806 3.98321 9.10236C9.99395 9.37323 13.0777 11.4823 12.7903 17.5642C11.7449 13.3167 6.7312 13.0167 4.32621 13.0167Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.70496 7.68565L1.58839 4.87856C1.38631 4.37052 1.76447 3.81894 2.31123 3.82525C8.44971 3.89607 12.7357 4.29645 12.7357 12.1816C11.6903 7.9341 5.10995 7.68565 2.70496 7.68565Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.98847 18.5191L4.83773 15.4191C4.65114 14.9164 5.02437 14.3813 5.55992 14.4087C10.4639 14.6598 12.9168 16.7172 12.6327 22.7287C11.5874 18.4811 8.41081 18.5191 5.98847 18.5191Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWindsurf);
export default __webpack_public_path__ + "static/media/windsurf.92bfb8e3d97c9f9689a87012be83a941.svg";
export { ForwardRef as ReactComponent };